import traverse from './traverse'

export default function next_segment($input) {
	traverse($input, 'next')
}
